import AbstractConfig from './AbstractConfig';
import {IInteractiveFormConfig} from '../../@interfaces/services/ConfigMaker/IInteractiveFormConfig';
import {IModelFormConfig} from '../../@interfaces/components/Form/IModelFormConfig';
import getUri, {withGetUriParams} from '../../helpers/getUri';
import {EndpointUri} from '../../@types/EndpointUri';
import app from '../../helpers/app';

export default class FormConfig extends AbstractConfig<IModelFormConfig & { controllerName: string, urlParams: { id?: string } }> implements IInteractiveFormConfig {
    getConfig(): IModelFormConfig & { controllerName: string, urlParams: { id?: string } } {
        return this.getAttributes();
    }

    getUrlOfGetModelRequestEndpoint(): string {
        return this.getModelRequestEndpoint(
            this.getConfig().getModelRequestEndpoint,
            'guessUrlOfGetModelRequestEndpoint'
        );
    }

    getUrlOfUpdateModelRequestEndpoint(): string {
        return this.getModelRequestEndpoint(
            this.getConfig().updateModelRequestEndpoint,
            'guessUrlOfUpdateModelRequestEndpoint'
        );
    }

    guessUrlOfGetModelRequestEndpoint(): string {
        return this.guessModelRequestEndpoint('show');
    }

    guessUrlOfUpdateModelRequestEndpoint(): string {
        return this.guessModelRequestEndpoint('update');
    }

    protected getModelRequestEndpoint(
        endpoint: EndpointUri | undefined,
        guessMethodName: 'guessUrlOfGetModelRequestEndpoint' | 'guessUrlOfUpdateModelRequestEndpoint'
    ) {
        const params = this.getConfig().urlParams;

        return withGetUriParams(params, () => getUri(endpoint)) || this[guessMethodName]();
    }

    protected guessModelRequestEndpoint(endpointName: 'show' | 'update') {
        const params = this.getConfig().urlParams;
        const methodName = endpointName === 'show' ? 'getShowRouteName' : 'getUpdateRouteName';

        return getUri({
            route: this.namesResolver.apiRoutes[methodName](this.getConfig().controllerName),
            params
        }, {
            route: this.namesResolver.apiRoutes[methodName](),
            params
        });
    }

    protected get namesResolver() {
        return app('names-resolver');
    }
}
